module.exports = __webpack_public_path__ + "img/pick4.bf0780bb.webp";